import type { CSSProperties } from 'react';

import { cn } from '@/lib/utils';

interface MHLogoDotsProps {
  size?: number;
  className?: string;
  'aria-label'?: string;
}

export function MHLogoDots({
  size,
  className,
  'aria-label': ariaLabel = 'mindhunters',
}: MHLogoDotsProps) {
  const style =
    size === undefined
      ? undefined
      : ({
          '--mh-dots-size': `${size}px`,
          '--mh-dots-gap': `calc(${size}px * 0.8)`,
        } as CSSProperties);

  return (
    <span className={cn('mh-logo-dots', className)} role="img" aria-label={ariaLabel} style={style}>
      <svg viewBox="0 0 46 10" aria-hidden="true" focusable="false">
        <circle cx="5" cy="5" r="5" fill="currentColor" />
        <circle cx="23" cy="5" r="5" fill="currentColor" />
        <circle cx="41" cy="5" r="5" fill="currentColor" />
      </svg>
    </span>
  );
}
